import React from "react";

const HeaderTitle = ({ title, description }) => {
  return (
    <div className="mb-5 min-w-0 sm:min-w-[240px]">
      <div className="flex items-start gap-3">
        <span
          className="mt-1.5 hidden sm:block h-8 w-1 rounded-full bg-main shrink-0"
          aria-hidden
        />
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl lg:text-[1.75rem] font-bold text-ink tracking-tight leading-tight">
            {title}
          </h1>
          {description ? (
            <p className="mt-1 text-sm text-inkSecondary/90 leading-snug max-w-2xl">
              {description}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default HeaderTitle;
